// extracted by mini-css-extract-plugin
module.exports = {"title":"Footer_title__2-0u5","col4":"Footer_col4__3ZhHV"};